import React from 'react';
import { useI18nContext } from '../../../contexts/I18nContext';
import TopupStatusSelectProperties from './TopupStatusSelectProperties';
import MultiSelect from "../../../ui_components/MultiSelect/MultiSelect";
import MultiSelectOption from "../../../ui_components/MultiSelect/MultiSelectOption";
import HistoryIcon from '@mui/icons-material/History';

const TopupStatusSelect: React.FC<TopupStatusSelectProperties> = ({
                                                                    selectedStatus,
                                                                    onChange,
                                                                    disabled,
                                                                    fullWidth = false,
                                                                    className = '',
                                                                }) => {

    const i18n = useI18nContext();

    const opt = [
        new MultiSelectOption("Procesando", "PROCESSING", "Procesando por el repartidor", selectedStatus?.some(r => r === "PROCESSING")),
        new MultiSelectOption("Reintentando", "RETRYING", "Reintentando", selectedStatus?.some(r => r === "RETRYING")),
        new MultiSelectOption("Completada", "COMPLETED", "Completada", selectedStatus?.some(r => r === "COMPLETED")),
        new MultiSelectOption("Cancelada", "CANCELED", "Cancelada", selectedStatus?.some(r => r === "CANCELED")),
    ]

    const onStatusChange = (options: MultiSelectOption[]) => {
        onChange(options.map(t => t.value));
    }

    return (
        <MultiSelect
            className={className}
            disabled={disabled}
            fullWidth={fullWidth}
            label={i18n.translate("REMITTANCE_STATUS")}
            placeholder={i18n.translate("STATUS_PLACEHOLDER")}
            icon={HistoryIcon}
            onChange={onStatusChange}
            elements={opt}
        />
    )
}

export default TopupStatusSelect;